import React, { Component } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import FamilyManagePage from 'modules/family/pages/manage/family-manage-page';
import { inject, observer } from 'mobx-react';
import FamilyBlockedPage from 'modules/family/pages/blocked/family-blocked-page';

@inject('store')
@observer
class FamilyModule extends Component {
    render() {
        const { match, store } = this.props;
        if (!store.user.hasFamilyTier) {
            return <FamilyBlockedPage />
        }

        return (
            <Switch>
                <Route path={match.path + '/manage'} component={FamilyManagePage} />
                <Redirect from={match.path} to={match.path + '/manage'} />
            </Switch>
        )
    }
}

export default FamilyModule;


// WEBPACK FOOTER //
// ./src/modules/family/family-module.js